import { useState } from "react";
import { useCart } from "../../context/CartContext";
import { createOrder } from "../../services/orderApi";
import { useNavigate } from "react-router-dom";
import { getSessionId } from "../../utils/session";
import "./checkout.css";

const CheckoutPage = () => {
  const { cartItems, reloadCart, clearCart } = useCart();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);

  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ================= FIXED ORDER CREATION =================
  const handlePlaceOrder = async (paymentMethod = "cod") => {
    try {
      setLoading(true);

      const sessionId = getSessionId();

      // 🔥 ADD PAYMENT METHOD ONLY (no logic change)
      const payload = {
    ...form,
    paymentMode: paymentMethod === "online" ? "PAY_NOW" : "COD",
    };


      const orderData = await createOrder(payload, sessionId);

      setOrder(orderData);

      clearCart();
      await reloadCart?.();

      const orderId = orderData.id;
      const orderCode = orderData.order_id;

      // ================= PAYMENT FLOW =================
      if (paymentMethod === "online") {
        navigate(`/payment/${orderId}`, {
          state: { orderCode },
        });
      }
      // COD → stay / show success screen

    } catch (err) {
      console.log(err);
      alert("Order failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= SUCCESS SCREEN =================
  if (order) {
    return (
      <div className="order-success">

        <h2>🎉 Order Placed Successfully</h2>

        <div className="order-box">
          <p><b>Order ID:</b> {order.order_id}</p>
          <p><b>Status:</b> {order.status}</p>
          <p><b>Total Items:</b> {order.total_items}</p>
          <p><b>Payment Status:</b> {order.payment_status}</p>
        </div>

        <button onClick={() => navigate("/track-order")} className="track-btn">
          Track Order
        </button>

        <button onClick={() => navigate("/shop")} className="shop-btn">
          Continue Shopping
        </button>

      </div>
    );
  }

  // ================= CHECKOUT FORM =================
  return (
    <div className="checkout-page">

      <h2>Checkout</h2>

      <div className="checkout-container">

        <div className="checkout-form">

          <input name="name" placeholder="Full Name" onChange={handleChange} />
          <input name="phone" placeholder="Phone" onChange={handleChange} />
          <input name="email" placeholder="Email (optional)" onChange={handleChange} />

          {/* ================= PAYMENT OPTIONS ================= */}
          <div className="payment-buttons">

            <button
              onClick={() => handlePlaceOrder("cod")}
              disabled={loading || cartItems.length === 0}
            >
              {loading ? "Placing Order..." : "Cash on Delivery"}
            </button>

            <button
              onClick={() => handlePlaceOrder("online")}
              disabled={loading || cartItems.length === 0}
              style={{ marginLeft: "10px" }}
            >
              Pay Now
            </button>

          </div>

        </div>

        <div className="checkout-summary">

          <h3>Order Summary</h3>

          {cartItems.map((item) => (
            <div key={item.id || item.product_id} className="row">
              <span>{item.name}</span>
              <span>₹{item.price}</span>
            </div>
          ))}

          <hr />

          <div className="row total">
            <b>Total</b>
            <b>₹{total.toFixed(2)}</b>
          </div>

        </div>

      </div>
    </div>
  );
};

export default CheckoutPage;
